(function() {
  /* Compilation number formula — must match yl-opening.liquid Liquid block:
       (current_year - 2023) * 365 + day_of_year_UTC
     This intentionally does NOT account for leap years, matching the Liquid
     computation which uses the same simplified formula. */
  function computeCompilationNumber() {
    var now = new Date();
    var year = now.getUTCFullYear();
    var startOfYear = Date.UTC(year, 0, 1);
    var doy = Math.floor((now.getTime() - startOfYear) / 86400000) + 1;
    var yearsElapsed = year - 2023;
    return String(yearsElapsed * 365 + doy).padStart(4, '0');
  }

  function loadPool() {
    var poolUrl = window.YL_CONTENT_POOL_URL || '/assets/content-pool.json';
    return fetch(poolUrl)
      .then(function(res) {
        if (!res.ok) throw new Error('pool load failed');
        return res.json();
      })
      .catch(function(e) {
        console.info('Compilation pool unavailable:', e.message);
        return null;
      });
  }

  function pickN(arr, seed, n) {
    if (!arr || arr.length === 0) return [];
    var result = [];
    for (var i = 0; i < n; i++) {
      result.push(arr[(seed + i) % arr.length]);
    }
    return result;
  }

  function pickOne(arr, seed) {
    if (!arr || arr.length === 0) return null;
    return arr[seed % arr.length];
  }

  function computeBurnsAtFajr() {
    var now = new Date();
    var fajr = new Date();
    fajr.setUTCHours(0, 42, 0, 0);
    if (now >= fajr) fajr.setUTCDate(fajr.getUTCDate() + 1);
    var diff = fajr - now;
    var hrs = Math.floor(diff / 3600000);
    var mins = Math.floor((diff % 3600000) / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    return [hrs, mins, secs].map(function(n) {
      return String(n).padStart(2, '0');
    }).join(':');
  }

  function updateLiveIST() {
    var el = document.getElementById('ist-clock') || document.querySelector('[data-ist-clock]');
    if (!el) return;
    var now = new Date();
    var ist = new Date(now.getTime() + (5.5 * 3600000));
    var h = String(ist.getUTCHours()).padStart(2, '0');
    var m = String(ist.getUTCMinutes()).padStart(2, '0');
    var s = String(ist.getUTCSeconds()).padStart(2, '0');
    el.textContent = h + ':' + m + ':' + s + ' IST';
  }

  function updateLivePKT() {
    var el = document.getElementById('pkt-clock') || document.querySelector('[data-pkt-clock]');
    if (!el) return;
    var now = new Date();
    var pkt = new Date(now.getTime() + (5 * 3600000));
    var h = String(pkt.getUTCHours()).padStart(2, '0');
    var m = String(pkt.getUTCMinutes()).padStart(2, '0');
    var s = String(pkt.getUTCSeconds()).padStart(2, '0');
    el.textContent = h + ':' + m + ':' + s + ' PKT';
  }

  function renderDispatchEntries(entries) {
    return entries.map(function(e) {
      return '<div class="dispatch-entry" style="margin-bottom:2.5rem;">' +
        '<span class="entry-label" style="font-family:\'Share Tech Mono\',monospace;font-size:0.75rem;letter-spacing:0.15em;text-transform:uppercase;color:var(--gold,#c8a45c);display:block;margin-bottom:0.5rem;">' + e.label + '</span>' +
        '<p style="font-family:\'Cormorant Garamond\',serif;font-size:1rem;line-height:1.75;max-width:580px;">' + e.body + '</p>' +
        '</div>';
    }).join('<hr style="border:none;border-top:1px solid rgba(200,164,92,0.25);margin:1.5rem 0;opacity:0.5;" role="presentation">');
  }

  function renderSahasranama(s) {
    return '<span class="sahasranama-header" style="font-family:\'Share Tech Mono\',monospace;font-size:0.75rem;letter-spacing:0.15em;text-transform:uppercase;color:rgba(200,164,92,0.55);display:block;margin-bottom:1.5rem;">NAME ' + s.number + ' · LALITĀ SAHASRANĀMA · SANCTUM ROTATION</span>' +
      '<span class="sahasranama-devanagari" style="font-family:\'Noto Serif Devanagari\',serif;font-size:3.5rem;line-height:1.15;text-align:center;display:block;margin:2.5rem 0;">' + s.devanagari + '</span>' +
      '<span class="sahasranama-iast" style="font-family:\'IM Fell English\',serif;font-style:italic;font-size:1.5rem;color:var(--ochre,#b07d3b);text-align:center;display:block;margin-bottom:1.5rem;">' + s.iast + '</span>' +
      '<span class="sahasranama-english" style="font-family:\'Cormorant Garamond\',serif;font-size:1.1rem;text-transform:uppercase;letter-spacing:0.08em;text-align:center;display:block;margin-bottom:2.5rem;">' + s.english + '</span>' +
      '<div class="sahasranama-commentary" style="font-family:\'Cormorant Garamond\',serif;font-size:1rem;line-height:1.65;max-width:640px;margin:0 auto;">' + s.commentary + '</div>';
  }

  function renderTransmission(tx) {
    return '<span class="tx-header" style="font-family:\'Share Tech Mono\',monospace;font-size:0.85rem;letter-spacing:0.12em;text-transform:uppercase;display:block;margin-bottom:1.5rem;padding-bottom:1rem;border-bottom:1px solid rgba(72,152,216,0.25);color:#4898D8;">' + tx.session + '</span>' +
      '<pre style="font-family:\'Inter\',sans-serif;font-size:0.9rem;line-height:1.85;white-space:pre-wrap;margin:0;padding:0;background:transparent;border:none;">' + tx.record_block + '</pre>';
  }

  function init() {
    var compNumber = computeCompilationNumber();

    document.querySelectorAll('[data-compilation-number]').forEach(function(el) {
      el.textContent = compNumber;
    });

    /* Wire compilation-number links to the permanent viewer URL */
    var compLinkHref = '/pages/compilation?id=YL-COMP-' + compNumber;
    document.querySelectorAll('[data-compilation-number-link]').forEach(function(el) {
      el.href = compLinkHref;
    });

    var timerEl = document.querySelector('[data-burns-at-fajr]');
    if (timerEl) {
      timerEl.textContent = computeBurnsAtFajr();
      setInterval(function() {
        timerEl.textContent = computeBurnsAtFajr();
      }, 1000);
    }

    setInterval(updateLiveIST, 1000);
    setInterval(updateLivePKT, 1000);
    updateLiveIST();
    updateLivePKT();

    loadPool().then(function(pool) {
      if (!pool) {
        console.info('Compilation running in static mode.');
        return;
      }

      var seed = parseInt(compNumber, 10);

      var dispatchEl = document.querySelector('[data-dispatch-entries]');
      if (dispatchEl && pool.dispatch_entries) {
        var entries = pickN(pool.dispatch_entries, seed, 3);
        dispatchEl.innerHTML = renderDispatchEntries(entries);
      }

      var sanctumEl = document.querySelector('[data-sahasranama-fragment]');
      if (sanctumEl && pool.sahasranama_names) {
        var s = pickOne(pool.sahasranama_names, seed);
        if (s) sanctumEl.innerHTML = renderSahasranama(s);
      }

      var marginEl = document.querySelector('[data-margin-notes]');
      if (marginEl && pool.margin_notes) {
        var notes = pickN(pool.margin_notes, seed, 3);
        marginEl.innerHTML = notes.map(function(n) {
          return '<div class="margin-note" style="margin-bottom:1.5rem;">' +
            '<span style="font-family:\'Share Tech Mono\',monospace;font-size:0.7rem;letter-spacing:0.15em;text-transform:uppercase;opacity:0.5;display:block;">' + (n.timestamp || 'MARGIN') + '</span>' +
            '<p style="font-family:\'Cormorant Garamond\',serif;font-size:0.95rem;line-height:1.6;">' + n.body + '</p>' +
            '</div>';
        }).join('');
      }

      var txEl = document.querySelector('[data-transmission-fragment]');
      if (txEl && pool.transmission_fragments) {
        var tx = pickOne(pool.transmission_fragments, seed);
        if (tx) txEl.innerHTML = renderTransmission(tx);
      }

      /* Chapter excerpts. The pool has always existed (20 entries); it had no
         handler, so nothing ever rendered one. Added 2026-07-29 for the OPERATION
         band of the homepage walk. */
      var excerptEl = document.querySelector('[data-chapter-excerpt]');
      if (excerptEl && pool.chapter_excerpts) {
        /* The pool mixes four books. An unfiltered pick puts a 1942 passage from
           Twenty-Four under a band whose status line reads PROJECT YODDHA, which
           reads as a mistake. The attribute's value narrows the pool by source. */
        var exPool = pool.chapter_excerpts;
        var want = (excerptEl.getAttribute('data-chapter-excerpt') || '').trim().toUpperCase();
        if (want) {
          var filtered = exPool.filter(function (e) {
            return (e.source || '').toUpperCase().indexOf(want) !== -1;
          });
          if (filtered.length) exPool = filtered;
        }
        var ex = pickOne(exPool, seed);
        if (ex) {
          excerptEl.innerHTML =
            '<span class="yl-frag__source">' + (ex.source || '') + '</span>' +
            (ex.title ? '<span class="yl-frag__title">' + ex.title + '</span>' : '') +
            '<p class="yl-frag__body">' + ex.body + '</p>';
        }
      }

      var pilotEl = document.querySelector('[data-featured-pilot]');
      if (pilotEl && pool.pilot_records) {
        var weeklySeed = Math.floor(seed / 7);
        var p = pickOne(pool.pilot_records, weeklySeed);
        if (p) {
          pilotEl.innerHTML = '<pre style="font-family:\'IM Fell English\',serif;font-size:0.9rem;line-height:1.8;white-space:pre-wrap;">' + p.record_block + '</pre>';
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
